/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalDistribution = {
    properties: {
        sixth1: {
            type: 'number',
            isRequired: true,
        },
        sixth2: {
            type: 'number',
            isRequired: true,
        },
        sixth3: {
            type: 'number',
            isRequired: true,
        },
        sixth4: {
            type: 'number',
            isRequired: true,
        },
        sixth5: {
            type: 'number',
            isRequired: true,
        },
        sixth6: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
